const MESSAGE_TEMPLATES = {
    success: {
        title: "Succès",
        message: "Votre message a été envoyé avec succès."
    },
    error: {
        title: "Erreur",
        message: "Une erreur s'est produite. Veuillez réessayer plus tard."
    },
    warning: {
        title: "Attention",
        message: "Veuillez vérifier vos informations."
    },
    info: {
        title: "Information",
        message: "Voici quelques informations importantes."
    }
};

function initContactForm() {
    const form = document.getElementById('contact-form');
    if (form) {
        // Créer et ajouter le loader
        createLoader();
        
        // Supprimer les anciens event listeners
        const newForm = form.cloneNode(true);
        form.parentNode.replaceChild(newForm, form);
        
        clearFormFields(newForm);
        newForm.addEventListener('submit', handleSubmit);
    }
}

function createLoader() {
    // Créer le loader s'il n'existe pas déjà
    if (!document.getElementById('contactFormLoader')) {
        const loader = document.createElement('div');
        loader.id = 'contactFormLoader';
        loader.className = 'contactFormLoader';
        
        const spinner = document.createElement('div');
        spinner.className = 'contactFormLoader__spinner';
        
        loader.appendChild(spinner);
        document.body.appendChild(loader);
    }
}

function showLoader() {
    const loader = document.getElementById('contactFormLoader');
    if (loader) {
        loader.classList.add('is-active');
    }
}

function hideLoader() {
    const loader = document.getElementById('contactFormLoader');
    if (loader) {
        loader.classList.remove('is-active');
    }
}

async function handleSubmit(e) {
    e.preventDefault();
    e.stopPropagation();
    
    const form = e.target;
    const formData = new FormData(form);
    
    try {
        showLoader();
        
        const response = await fetch('/server-side/process-form.php', {
            method: 'POST',
            body: formData
        });
        
        const text = await response.text();
        
        if (response.ok) {
            showMessage('success');
            clearFormFields(form);
        } else {
            showMessage('error', text);
        }
    } catch (error) {
        console.error('Fetch error:', error);
        showMessage('error');
    } finally {
        hideLoader();
    }
}

function clearFormFields(form) {
    const inputs = form.querySelectorAll('input, textarea');
    inputs.forEach(input => {
        input.value = '';
    });
}

function showMessage(type, customMessage = null) {
    const messageWrapper = document.getElementById('message-wrapper');
    messageWrapper.innerHTML = '';
    
    const template = MESSAGE_TEMPLATES[type];
    const title = template.title;
    const message = customMessage || template.message;

    const messageBox = document.createElement('div');
    messageBox.className = `message-box ${type}`;
    
    const titleElement = document.createElement('h3');
    titleElement.className = 'message-title';
    titleElement.textContent = title;
    
    const messageElement = document.createElement('p');
    messageElement.className = 'message-content';
    messageElement.textContent = message;
    
    messageBox.appendChild(titleElement);
    messageBox.appendChild(messageElement);
    messageWrapper.appendChild(messageBox);

    gsap.fromTo(messageBox,
        { opacity: 0, y: 30 },
        { opacity: 1, y: 0, duration: 0.5, ease: "power2.out" }
    );

    setTimeout(() => {
        gsap.to(messageBox, {
            opacity: 0,
            y: 30,
            duration: 0.5,
            ease: "power2.in",
            onComplete: () => messageBox.remove()
        });
    }, 4500);
}

export { initContactForm };